import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { ILoader } from '~/_base/components/helixIcons';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

interface Props {
  delay?: number;
  message?: string;
  fullScreen?: boolean;
}

export default function Spinner(props: Props) {
  const { delay, message } = props;
  const classes = useStyles();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  });

  return show === true ? (
    <div
      className={clsx([
        classes.root,
        {
          [classes.fullScreen]: props.fullScreen,
        },
      ])}
    >
      <ILoader fontSize="large" className={classes.spinner} />
      <Typography>{message}</Typography>
    </div>
  ) : null;
}

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {
    margin: theme.spacing(2),
  },
  fullScreen: {
    margin: 0,
    position: 'fixed',
    paddingTop: '30vh',
    backgroundColor: 'rgb(0,0,0,0.2)',
    zIndex: 1399, // 1 below Material-UI snackbars (error/success etc)
    width: '100vw',
    height: '100vh',
    display: 'block',
    textAlign: 'center',
  },
}));
